import type { AiClientInterface } from './aiClient.types';
import CorporateAiClient from './corporateAiClient';
import GroupAiClient from './groupAiClient';
import type { ClientContext } from '~/services/contextClient';

export default class AiClientFactory {
    static createClient(context: ClientContext): AiClientInterface {
        if (context.groupId) {
            return new GroupAiClient(context.teamId, context.groupId);
        }

        return new CorporateAiClient(context.teamId);
    }
}
